import { CountryCode } from '~/core/enums';

import apiSlice from './apiSlice';

export const defaultLocationData = CountryCode.None;
export const { useLocationQuery } = apiSlice;
